module.exports = __webpack_public_path__ + "img/room4.3d158688.gif";